import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { LabOSAuth } from './lib/labos.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LabOSAuth appId="content-lab-template">
      <App />
    </LabOSAuth>
  </StrictMode>,
);
